import React from "react";
import { Card, Box, Avatar, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import BedIcon from "@mui/icons-material/Bed";

const RoomSharingCard = ({ users = [], label }) => {
    return (
        <Card

            sx={{
                borderRadius: "10px",
                p: 1,
            }}
        >
            <Box display="flex" alignItems="center" gap={1} mb={1}>
                <BedIcon sx={{ fontSize: 16, color: "#7D49FE" }} />
                <Typography
                    fontSize="16px"
                    fontWeight={600}
                    sx={{ color: "#7D49FE" }}
                >
                    {label}
                </Typography>
            </Box>
            {users.map((user, idx) => (
                <Box
                    key={idx}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    mb={1}
                    sx={{
                        p: 0.5,
                        borderRadius: "6px",
                    }}
                >
                    <Avatar
                        sx={{
                            width: 28,
                            height: 28,
                            bgcolor: "#7D49FE",
                        }}
                    >
                        <PersonIcon sx={{ fontSize: 16 }} />
                    </Avatar>

                    <Box>
                        <Typography fontSize="16px" fontWeight={700} fontStyle={"bold"} lineHeight={"30px"}>
                            {user.name}
                        </Typography>
                        <Typography fontSize="14px" color="black" fontWeight={400}>
                            {user.location || "—"}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Card>
    );
};

export default RoomSharingCard;